import { OnInit, Optional, Inject, Component } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { BalancesService } from '../../services/balances.services';
import { BalancesResponse, CurrencyDetail } from '../../model/index';
import { BalancesConstants } from '../../utils/balances-constants';
import { BalancesLabels } from '../../i18n/balances-labels';

@Component({
    selector: 'modern-theme-currency-details',
    templateUrl: './currency-balances.component.html'
})
export class CurrencyBalancesComponent implements OnInit {

    header: string = BalancesLabels.CURRENCY_LABELS_CURRENCYBALANCESHEADER;
    theme: string = 'standard';
    balancesResponse: BalancesResponse;
    SystemErrorMsg: string;
    isLoading: boolean = true;
    noDataMsg: string = '';
    showCurrencyContent: boolean = false;
    isBankCustodyAccount: boolean = false;
    baseCurrency: string = '';
    netTotalCurrencyIndicator: string = 'Net ';

    showFXLink: boolean = true;

    balancesServiceErrorSub: any;
    balancesResponseErrorSub: any;
    fetchingBalancesDataSub: any;
    showDelayedQuoteLegendSub: any;
    balancesResponseSub: any;
    showDelayedQuoteLegend: boolean = true;

    constructor(
        private translationService: PershingTranslationService,
        private balancesService: BalancesService,
        @Optional() @Inject('AppSettings') appSettings: any
    ) {
        if (!!appSettings && !!appSettings.ibdConfigMap && !!appSettings.ibdConfigMap.themeType) {
            this.theme = appSettings.ibdConfigMap.themeType;
        }
    }

    ngOnInit() {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-balances', 'node_modules/@pershing/nxi-ng-balances/lib');

        // Generic, http error e.g. 500.
        this.balancesServiceErrorSub = this.balancesService.balancesServiceError$.subscribe(error => {
            this.SystemErrorMsg = !!error && !!error.errorMessage ? error.errorMessage : '';
            this.isLoading = false;
        });

        // Got BalancesResponse but has 'errorCode' of non-zero.
        this.balancesResponseErrorSub = this.balancesService.balancesResponseError$.subscribe(error => {
            this.SystemErrorMsg = !!error && !!error.errorMessage ? error.errorMessage : '';
            this.isLoading = false;
        });

        // loading
        this.fetchingBalancesDataSub = this.balancesService.fetchingBalancesData$.subscribe(fetching => {
            this.isLoading = !!fetching ? fetching : false;
        });

        // Hide on Balances (detail/summary) fetching.
        this.fetchingBalancesDataSub = this.balancesService.fetchingBalancesData$.subscribe(fetching => {
            if (fetching) {
                this.showCurrencyContent = false;
            }
        });

        this.balancesResponseSub = this.balancesService.balancesResponse$.subscribe(data => {
            if (!!data && !!data.response) {
                this.showCurrencyContent = false;
                this.processCurrencyDetail(data);
            }
        });
        this.balancesService.setShowCurrencyDetails(this.showCurrencyContent);
        this.showDelayedQuoteLegendSub = this.balancesService.realtimeQuote$.subscribe(realtime => {
            this.showDelayedQuoteLegend = !realtime;
        });
    }

    processCurrencyDetail(data: BalancesResponse) {

        if (!data || !data.response || typeof data.response.balances === 'undefined' ||
            data.response.balances.balancesDetails === null ||
            typeof data.response.balances.balancesDetails.localCurrencyDetailList === 'undefined' ||
            typeof data.response.balances.balancesDetails.usdeCurrencyDetailList === 'undefined') {
            return;
        }

        let response = data.response;

        this.baseCurrency = this.balancesService.displayParams$.baseCurrency;
        this.isBankCustodyAccount = this.balancesService.displayParams$.isCustodian;

        // Pick the right list per based currency.
        let cl: CurrencyDetail[] = this.baseCurrency === BalancesConstants.USD_CURRENCY ?
            response.balances.balancesDetails.localCurrencyDetailList : response.balances.balancesDetails.usdeCurrencyDetailList;

        // Wheather to show this component at all
        if (!this.showCurrencyContentCheck(cl)) {
            return;
        }

        this.balancesResponse = data;

    }

    showCurrencyContentCheck(currencyList: any[]) {
        // Expect data be of 'Net USDE' - with
        //      'Net' indicating it's NET value - calculated based on the 'base currency' for all currencies.
        //      'USDE' is being the 'base currency' used to calculate the NET total.
        // If no such data exist, we'd not show.
        this.showCurrencyContent = currencyList && currencyList.some((cc: CurrencyDetail[]) => {
            return cc.some((item: CurrencyDetail) => {
                return item.localCcy.indexOf(this.netTotalCurrencyIndicator) !== -1;
            });
        });
        if(this.showCurrencyContent === null){
            this.showCurrencyContent = false;
        }
        this.balancesService.setShowCurrencyDetails(this.showCurrencyContent);
        return this.showCurrencyContent;
    }

    ngOnDestroy(): void {
        if (this.balancesServiceErrorSub) {
            this.balancesServiceErrorSub.unsubscribe();
        }
        if (this.balancesResponseErrorSub) {
            this.balancesResponseErrorSub.unsubscribe();
        }
        if (this.fetchingBalancesDataSub) {
            this.fetchingBalancesDataSub.unsubscribe();
        }
        if (this.showDelayedQuoteLegendSub) {
            this.showDelayedQuoteLegendSub.unsubscribe();
        }
        if (this.balancesResponseSub) {
            this.balancesResponseSub.unsubscribe();
        }
    }
}
